<template>
  <div id="footer-nav">
    <el-menu
      text-color="#707173"
      active-text-color="#707173"
      mode="horizontal"
      :router="true">
      <el-menu-item index="/pathto">会社概要</el-menu-item>
      <el-menu-item index="/pathto">プライバシーポリシー</el-menu-item>
      <el-menu-item index="/pathto">利用規約</el-menu-item>
      <el-menu-item index="/pathto">お問い合わせ</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'footer-nav'
}
</script>

<style scoped>
.el-menu--horizontal{
  border-top:solid 1px #e6e6e6;
  border-bottom:none;
}
.el-menu-item.is-active{
  border-bottom:none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/02-organisms/FooterNav.vue